/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voices_DescriptionInputs */

const en_settings_voices_description = /** @type {(inputs: Settings_Voices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your preferred voice.`)
};

const es_settings_voices_description = /** @type {(inputs: Settings_Voices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona tu voz preferida.`)
};

/**
* | output |
* | --- |
* | "Select your preferred voice." |
*
* @param {Settings_Voices_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voices_description = /** @type {((inputs?: Settings_Voices_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voices_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voices_description(inputs)
	return en_settings_voices_description(inputs)
});